import { render } from "./ProfileImage.vue?vue&type=template&id=5b104dfa&ts=true"
import script from "./ProfileImage.vue?vue&type=script&lang=ts"
export * from "./ProfileImage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__